import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppSelector } from "@/hooks/useAppSelector";

export function SplashScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, companySetupComplete } = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    } else if (!companySetupComplete) {
      navigate("/company-setup");
    } else if (location.pathname === "/") {
      // Only redirect to home if we're actually on the root path
      navigate("/");
    }
    // We don't include navigate in deps as it would cause unnecessary reruns
  }, [isAuthenticated, companySetupComplete, location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary/5 to-primary/10">
      <div className="text-center space-y-4 animate-fade-in">
        <h1 className="text-4xl font-bold bg-gradient-to-r from-primary to-blue-600 bg-clip-text text-transparent">
          THMN.AI
        </h1>
        <p className="text-slate-600 dark:text-slate-400">
          Transforming your business with AI
        </p>
        <div className="w-16 h-16 mx-auto relative">
          <div className="w-full h-full border-4 border-primary/30 border-t-primary rounded-full animate-spin"></div>
        </div>
      </div>
    </div>
  );
}